import {gql} from 'apollo-boost';

export const GET_SUBJECTGROUPS = gql`
  query getSubjectGroups{
    getSubjectGroups {
      id
      code
      nameLocal
      nameEng
      label
      degree{
        id code nameLocal nameEng
      }
      faculty{
        id code nameLocal nameEng
      }
    }
  }
`;

export const GET_SUBJECTGROUP = gql`
  query getSubjectGroup($id: ID!){
    getSubjectGroup (
      id: $id
    ) {
      id
      code
      nameLocal
      nameEng
      label
      degree{
        id code nameLocal nameEng
      }
      faculty{
        id code nameLocal nameEng
      }
    }
  }
`;

export const ADD_SUBJECTGROUP = gql`
  mutation addSubjectGroup(
    $degreeId: ID,
    $facultyId: ID,
    $code: String!,
    $nameLocal: String!,
    $nameEng: String!,
  ) {
    addSubjectGroup(
      degreeId: $degreeId
      facultyId: $facultyId
      code: $code
      nameLocal: $nameLocal
      nameEng: $nameEng
    ) {
      id
      code
      nameLocal
      nameEng
      degree{
        id code nameLocal nameEng
      }
      faculty{
        id code nameLocal nameEng
      }
    }
  }
`;

export const UPDATE_SUBJECTGROUP = gql`
  mutation updateSubjectGroup(
    $degreeId: ID,
    $facultyId: ID,
    $id: ID!,
    $code: String!,
    $nameLocal: String!,
    $nameEng: String!,
  ) {
    updateSubjectGroup(
      id: $id
      degreeId: $degreeId
      facultyId: $facultyId
      code: $code
      nameLocal: $nameLocal
      nameEng: $nameEng
    ) {
      id
      code
      nameLocal
      nameEng
      degree{
        id code nameLocal nameEng
      }
      faculty{
        id code nameLocal nameEng
      }
    }
  }
`;

export const DELETE_SUBJECTGROUP = gql`
  mutation deleteSubjectGroup($id: ID!) {
    deleteSubjectGroup(
      id: $id
    ) {
      id
      code
      nameLocal
      nameEng
      degree{
        id code nameLocal nameEng
      }
      faculty{
        id code nameLocal nameEng
      }
    }
  }
`;

